import './NoObjectsAlert.scss';

import { AsyncStateNotification } from '@ui/notifications';
import { Button } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import { ErrorOrFailStatusCode } from '@sonar-software/sonar-http';
import { FullUserBoundary } from '@ui/general';
import { SonarAlert } from '@ui/SonarAlert';
import { SonarText } from '@ui/text';
import { useAction } from '@hooks';
import { useNavigate } from 'react-router';

import { CHANGE_EVENT_PREFERENCES, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

const postDataSecurityMonitoredObjectsSelectors = createAsyncSelectors((state) => state.core.dataSecurity.monitoredObjects.post);

export type NoObjectsAlertProps = {
	failed?: boolean;
	onRefresh: () => void;
};

export const NoObjectsAlert : React.FC<NoObjectsAlertProps> = ({ failed, onRefresh }) => {
	const postMonitoredObjects = useAction(coreActions.requestPostCoreDataSecurityMonitoredObjects);
	const navigate = useNavigate();

	const handleUseSuggestedClick = useCallback(() => {
		postMonitoredObjects();
	}, [ postMonitoredObjects ]);

	const handleReauthenticateClick = useCallback(() => {
		navigate(FULL_ROUTES.SETTINGS_ORGANIZATION);
	}, [ navigate ]);

	return (
		<>
			<SonarAlert
				active
				closable={ !failed }
				message={
					failed ?
						<div className='no-objects-message'>
							<SonarText>{ CHANGE_EVENT_PREFERENCES.SALESFORCE_CREDENTIALS_EXPIRED }</SonarText>
							<FullUserBoundary>
								<Button
									className='suggested-objects-button'
									onClick={ handleReauthenticateClick }
									type='primary'>
									{ CHANGE_EVENT_PREFERENCES.REAUTHENTICATE }
								</Button>
							</FullUserBoundary>
						</div> :
						<div className='no-objects-message'>
							<SonarText>{ CHANGE_EVENT_PREFERENCES.NO_OBJECTS_SELECTED }</SonarText>
							<FullUserBoundary>
								<Button
									className='suggested-objects-button'
									onClick={ handleUseSuggestedClick }
									type='primary'>
									{ CHANGE_EVENT_PREFERENCES.USE_SUGGESTED_OBJECTS }
								</Button>
							</FullUserBoundary>
						</div>
				}
				showIcon
				type='warning' />
			<AsyncStateNotification
				byStatusCode={ [
					{
						options: {
							description: CHANGE_EVENT_PREFERENCES.SELECT_SUGGESTED_OBJECTS_ERROR,
							options: { message: CHANGE_EVENT_PREFERENCES.OBJECTS_ALREADY_SELECTED }
						},
						statusCode: ErrorOrFailStatusCode.Conflict
					}
				] }
				resetAction={ onRefresh }
				stateSelector={ postDataSecurityMonitoredObjectsSelectors.state } />
		</>
	);
};
